import { ActionCard } from "."
import { AsideActionCard } from "./AsideActionCard"
import { PrCard } from "./PrCard"

import styles from "./Action.module.scss"

import type { ActionListCardComponent } from "."

export const ActionListCard: ActionListCardComponent = (props) => {
  const { tickets, pullRequests, type, issueId } = props
  const hasTickets = tickets && tickets.length > 0
  const hasPullRequests = pullRequests && pullRequests.length > 0

  if (!hasTickets && !hasPullRequests) return null

  return (
    <div className={styles.listCard}>
      {tickets?.map((ticket, index) => (
        <ActionCard
          key={`ticket-${index}`}
          ticket={ticket}
          type={type}
          aside={
            !!issueId && <AsideActionCard ticket={ticket} issueId={issueId} />
          }
        />
      ))}
      {pullRequests?.map((pr, index) => (
        <PrCard key={`pr-${index}`} pr={pr} type={type} />
      ))}
    </div>
  )
}
